import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import MemberContext from "../../../context/MemberProvider";
import {
	getDashboardSummary,
	getPortalUserByEmail,
} from "../../../api/apiServices";
import { format } from "date-fns";
import "./Home.css";

const dateFormat = "dd-MM-yyyy";

function Home() {
	const { mem } = useContext(MemberContext);
	const pfNumber = mem?.pfNumber;
	const email = mem.email;

	const { data: portal_user } = useQuery(["portal_user", email], () =>
		getPortalUserByEmail(email)
	);

	const { data: memDashboard } = useQuery(["memDashboard", pfNumber], () =>
		getDashboardSummary(pfNumber)
	);

	let totalMandatoryPayments = 0;
	let totalOtherPayments = 0;

	let mandatoryPaymentData = [];
	let otherPaymentData = [];

	let manPaymentDetail = memDashboard?.mandatoryPaymentDetails;
	let othPaymentDetail = memDashboard?.otherPaymentDetails;

	// Detail Mandatory Payment Information
	for (var i = 0; i < manPaymentDetail?.length; i++) {
		totalMandatoryPayments += manPaymentDetail[i].payment_amount;
		mandatoryPaymentData.push({
			year: manPaymentDetail[i].year,
			payment_date: manPaymentDetail[i].payment_date
				? format(new Date(manPaymentDetail[i].payment_date), dateFormat)
				: null,
			receipt_number: manPaymentDetail[i].receipt_number,
			payment_type: manPaymentDetail[i].payment_type,
			description: manPaymentDetail[i].description,
			payment_amount: manPaymentDetail[i].payment_amount.toLocaleString(
				undefined,
				{ minimumFractionDigits: 2 }
			),
		});
	}

	// Deatil Other Payment Information
	for (var j = 0; j < othPaymentDetail?.length; j++) {
		totalOtherPayments += othPaymentDetail[j].payment_amount;
		otherPaymentData.push({
			year: othPaymentDetail[j].year,
			payment_date: othPaymentDetail[j].payment_date
				? format(new Date(othPaymentDetail[j].payment_date), dateFormat)
				: null,
			receipt_number: othPaymentDetail[j].receipt_number,
			payment_type: othPaymentDetail[j].payment_type,
			description: othPaymentDetail[j].description,
			payment_amount: othPaymentDetail[j].payment_amount.toLocaleString(
				undefined,
				{ minimumFractionDigits: 2 }
			),
		});
	}

	const accountSummary = (
		<>
			<div className="member-dashboard">
				<div className="dashboard-box">
					<div className="dashboard-text">
						<h4>Opening Balance</h4>
					</div>
					<hr />
					<div className="dashboard-amt">
						{memDashboard?.ledger[0]?.opening_balance < 0 ? (
							<h5>
								(
								{(
									memDashboard?.ledger[0]?.opening_balance *
									-1
								).toLocaleString(undefined, {
									minimumFractionDigits: 2,
								})}
								)
							</h5>
						) : (
							<h5>
								{memDashboard?.ledger[0]?.opening_balance.toLocaleString(
									undefined,
									{ minimumFractionDigits: 2 }
								)}
							</h5>
						)}
					</div>
				</div>
				<div className="dashboard-box">
					<div className="dashboard-text">
						<h4>Mandatory Payment</h4>
					</div>
					<hr />
					<div className="dashboard-amt">
						{memDashboard?.ledger[0]?.expected_total_amount < 0 ? (
							<h5>
								(
								{(
									memDashboard?.ledger[0]
										?.expected_total_amount * -1
								).toLocaleString(undefined, {
									minimumFractionDigits: 2,
								})}
								)
							</h5>
						) : (
							<h5>
								{memDashboard?.ledger[0]?.expected_total_amount.toLocaleString(
									undefined,
									{ minimumFractionDigits: 2 }
								)}
							</h5>
						)}
					</div>
				</div>
				<div className="dashboard-box">
					<div className="dashboard-text">
						<h4>Total Amount Paid</h4>
					</div>
					<hr />
					<div className="dashboard-amt">
						<h5>
							{memDashboard?.ledger[0]?.total_amount_paid.toLocaleString(
								undefined,
								{ minimumFractionDigits: 2 }
							)}
						</h5>
					</div>
				</div>
				<div className="dashboard-box">
					<div className="dashboard-text">
						<h4>Closing Balance</h4>
					</div>
					<hr />
					<div className="dashboard-amt">
						{memDashboard?.ledger[0]?.closing_balance < 0 ? (
							<h5>
								(
								{(
									memDashboard?.ledger[0]?.closing_balance *
									-1
								).toLocaleString(undefined, {
									minimumFractionDigits: 2,
								})}
								)
							</h5>
						) : (
							<h5>
								{memDashboard?.ledger[0]?.closing_balance.toLocaleString(
									undefined,
									{ minimumFractionDigits: 2 }
								)}
							</h5>
						)}
					</div>
				</div>
			</div>
		</>
	);

	const manPaymtSummary = (
		<>
			<legend className="home-legend">Mandatory Payment Summary</legend>
			<div className="table-responsive lg">
				<table className="table table-borderless table-hover table-striped">
					<thead>
						<tr>
							<th style={{ textAlign: "left" }}>Action</th>
							<th style={{ textAlign: "center" }}>Year</th>
							<th style={{ textAlign: "center" }}>
								Payment Date
							</th>
							<th style={{}}>Description</th>
							<th style={{ textAlign: "right" }}>Amount (GHS)</th>
						</tr>
					</thead>
					<tbody>
						{memDashboard?.mandatoryPaymentSummary?.map(
							(payment, index) => (
								<tr key={index}>
									<td
										style={{
											width: "25%",
											textAlign: "left",
										}}
									>
										<div>
											{/* <Link to={`/mandatory_payment_details/key=${payment.payment_type.replaceAll(" ","_")}`}> <i className='fa fa-eye'></i> View Details</Link> */}
											<Link
												to={`/mandatory_payment_details/${payment.receipt_number}`}
											>
												{" "}
												<i className="fa fa-eye"></i>{" "}
												View Details
											</Link>
										</div>
									</td>
									<td style={{ textAlign: "center" }}>
										{payment.year}
									</td>
									<td style={{ textAlign: "center" }}>
										{payment.payment_date
											? format(
													new Date(
														payment.payment_date
													),
													dateFormat
											  )
											: null}
									</td>
									<td style={{ textTransform: "uppercase" }}>
										{payment.payment_type}
									</td>
									<td style={{ textAlign: "right" }}>
										{payment.payment_amount.toLocaleString(
											undefined,
											{ minimumFractionDigits: 2 }
										)}
									</td>
								</tr>
							)
						)}
					</tbody>
					<tbody>
						<tr>
							<td colSpan="8"></td>
						</tr>
						<tr>
							<td
								colSpan="4"
								className="border-bottom"
								style={{
									width: "55%",
									textAlign: "left",
									fontSize: "16px",
									fontWeight: "700",
									color: "green",
								}}
							>
								TOTAL MANDATORY PAYMENTS
							</td>
							{totalMandatoryPayments < 0 ? (
								<td
									className="border-bottom"
									style={{
										width: "40%",
										textAlign: "right",
										fontSize: "16px",
										fontWeight: "700",
										color: "green",
									}}
								>
									(
									{(
										totalMandatoryPayments * -1
									).toLocaleString(undefined, {
										minimumFractionDigits: 2,
									})}
									){" "}
								</td>
							) : (
								<td
									className="border-bottom"
									style={{
										width: "40%",
										textAlign: "right",
										fontSize: "16px",
										fontWeight: "700",
										color: "green",
									}}
								>
									{totalMandatoryPayments.toLocaleString(
										undefined,
										{ minimumFractionDigits: 2 }
									)}{" "}
								</td>
							)}
						</tr>
						<tr>
							<td
								colSpan="8"
								style={{ width: "95%", borderBottom: "5px" }}
							></td>
						</tr>
					</tbody>
				</table>
			</div>
		</>
	);

	const othPaymtSummary = (
		<>
			<legend className="home-legend">Other Payment Summary</legend>
			<div className="table-responsive lg">
				<table className="table table-borderless table-hover table-striped">
					<thead>
						<tr>
							<th style={{ textAlign: "left" }}>Action</th>
							<th style={{ textAlign: "center" }}>Year</th>
							<th style={{ textAlign: "center" }}>
								Payment Date
							</th>
							<th style={{}}>Description</th>
							<th style={{ textAlign: "right" }}>Amount (GHS)</th>
						</tr>
					</thead>
					<tbody>
						{memDashboard?.otherPaymentSummary?.map(
							(payment, index) => (
								<tr key={index}>
									<td
										style={{
											width: "25%",
											textAlign: "left",
										}}
									>
										<div>
											{/* <Link to={`/other_payment_details/key=${payment.payment_type.replaceAll(" ","_")}`}> <i className='fa fa-eye'></i> View Details</Link> */}
											<Link
												to={`/other_payment_details/${payment.receipt_number}`}
											>
												{" "}
												<i className="fa fa-eye"></i>{" "}
												View Details
											</Link>
										</div>
									</td>
									<td style={{ textAlign: "center" }}>
										{payment.year}
									</td>
									<td style={{ textAlign: "center" }}>
										{payment.payment_date
											? format(
													new Date(
														payment.payment_date
													),
													dateFormat
											  )
											: null}
									</td>
									<td style={{ textTransform: "uppercase" }}>
										{payment.description}
									</td>
									<td style={{ textAlign: "right" }}>
										{payment.payment_amount.toLocaleString(
											undefined,
											{ minimumFractionDigits: 2 }
										)}
									</td>
								</tr>
							)
						)}
					</tbody>
					<tbody>
						<tr>
							<td colSpan="8"></td>
						</tr>
						<tr>
							<td
								colSpan="4"
								className="border-bottom"
								style={{
									width: "55%",
									textAlign: "left",
									fontSize: "16px",
									fontWeight: "700",
									color: "green",
								}}
							>
								TOTAL OTHER PAYMENTS
							</td>
							{totalOtherPayments < 0 ? (
								<td
									className="border-bottom"
									style={{
										width: "40%",
										textAlign: "right",
										fontSize: "16px",
										fontWeight: "700",
										color: "green",
									}}
								>
									(
									{(totalOtherPayments * -1).toLocaleString(
										undefined,
										{ minimumFractionDigits: 2 }
									)}
									){" "}
								</td>
							) : (
								<td
									className="border-bottom"
									style={{
										width: "40%",
										textAlign: "right",
										fontSize: "16px",
										fontWeight: "700",
										color: "green",
									}}
								>
									{totalOtherPayments.toLocaleString(
										undefined,
										{ minimumFractionDigits: 2 }
									)}{" "}
								</td>
							)}
						</tr>
						<tr>
							<td
								colSpan="8"
								style={{ width: "95%", borderBottom: "5px" }}
							></td>
						</tr>
					</tbody>
				</table>
			</div>
		</>
	);

	const ledgerAccount = (
		<>
			<legend className="home-legend">Ledger - Mandatory Payments</legend>
			<div className="table-responsive lg">
				<table className="table table-borderless table-hover table-striped">
					<thead>
						<tr>
							<th style={{ textAlign: "center" }}>Year</th>
							<th style={{ textAlign: "center" }}>Date</th>
							<th style={{ textAlign: "right" }}>
								Opening Balance
							</th>
							<th style={{ textAlign: "right" }}>
								Expected Payment
							</th>
							<th style={{ textAlign: "right" }}>Amount Paid</th>
							<th style={{ textAlign: "right" }}>
								Closing Balance{" "}
							</th>
						</tr>
					</thead>
					<tbody>
						{memDashboard?.ledger?.map((ledger) => (
							<>
								<tr key={ledger?.id}>
									<td style={{ textAlign: "center" }}>
										{ledger?.year}
									</td>
									<td style={{ textAlign: "center" }}>
										{ledger?.transaction_date
											? format(
													new Date(
														ledger?.transaction_date
													),
													dateFormat
											  )
											: null}
									</td>
									{ledger?.opening_balance < 0 ? (
										<td style={{ textAlign: "right" }}>
											(
											{(
												ledger?.opening_balance * -1
											).toLocaleString(undefined, {
												minimumFractionDigits: 2,
											})}
											){" "}
										</td>
									) : (
										<td style={{ textAlign: "right" }}>
											{ledger?.opening_balance.toLocaleString(
												undefined,
												{ minimumFractionDigits: 2 }
											)}{" "}
										</td>
									)}
									{ledger?.expected_total_amount < 0 ? (
										<td style={{ textAlign: "right" }}>
											(
											{(
												ledger?.expected_total_amount *
												-1
											).toLocaleString(undefined, {
												minimumFractionDigits: 2,
											})}
											){" "}
										</td>
									) : (
										<td style={{ textAlign: "right" }}>
											{ledger?.expected_total_amount.toLocaleString(
												undefined,
												{ minimumFractionDigits: 2 }
											)}{" "}
										</td>
									)}
									<td style={{ textAlign: "right" }}>
										{ledger?.total_amount_paid.toLocaleString(
											undefined,
											{ minimumFractionDigits: 2 }
										)}{" "}
									</td>
									{ledger?.closing_balance < 0 ? (
										<td style={{ textAlign: "right" }}>
											(
											{(
												ledger?.closing_balance * -1
											).toLocaleString(undefined, {
												minimumFractionDigits: 2,
											})}
											){" "}
										</td>
									) : (
										<td style={{ textAlign: "right" }}>
											{ledger?.closing_balance.toLocaleString(
												undefined,
												{ minimumFractionDigits: 2 }
											)}{" "}
										</td>
									)}
								</tr>
							</>
						))}
					</tbody>
				</table>
			</div>
		</>
	);

	return (
		<>
			<section className="content-header">
				<h1>
					Dashboard - {portal_user?.first_name}{" "}
					{portal_user?.middle_name} {portal_user?.last_name}
				</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>Dashboard Summary</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">
								<fieldset className="col-md-12">
									{accountSummary}
									{manPaymtSummary}
									{othPaymtSummary}
									{ledgerAccount}
								</fieldset>
							</div>
						</div>
					</div>
					<div className="box-footer"></div>
				</div>
			</section>
		</>
	);
}

export default Home;
